@if (loading$ | async) {
  <sh-spinner size="s"></sh-spinner>
} @else {
  <sh-icon
    icon="refresh"
    id="refresh-icon"
    size="s"
    label="refresh"
    aria-label="Refresh"
    button
    (click)="refresh()"
  ></sh-icon
  ><sh-tooltip target="refresh-icon">
    <sh-text size="body-2" color="primary">
      {{ 'label.refreshPanel.tooltip' | translate }} <br />
      <span class="from-now">{{ lastRefresh | timeFromNow }}</span>
    </sh-text>
  </sh-tooltip>
}
